import { createSelector } from '@reduxjs/toolkit';

export const errorStates = (state) => state?.error;

export const hasErrored = createSelector(errorStates, (errorStates) => errorStates?.hasErrored);

export const pageError = createSelector(errorStates, (errorStates) => errorStates?.pageError);

export const alternateErrorString = createSelector(errorStates, (errorStates) => errorStates?.alternateErrorString);
